import { InvalidScientificEntryError } from '../../domain/errors/InvalidScientificEntryError';
import type { ScientificEntryRepository } from '../../domain/repositories/ScientificEntryRepository.interface';
import type { ScientificEntryCategory } from '../../domain/entities/ScientificEntry.entity';
import type { ScientificEntryDto } from '../dto/ScientificEntryDto';
import { ApplicationError, ValidationError, type Logger } from '@dma/shared';

export class GetScientificEntryBySlugUseCase {
  constructor(
    private readonly repository: ScientificEntryRepository,
    private readonly logger: Logger
  ) {}

  public async execute(category: ScientificEntryCategory, slug: string): Promise<ScientificEntryDto> {
    let entry;
    try {
      entry = await this.repository.getPublishedBySlug(category, slug);
    } catch (error) {
      if (error instanceof InvalidScientificEntryError) {
        this.logger.error('Scientific entry content failed domain validation', {
          category,
          slug,
          code: error.code,
          message: error.message
        });
        throw new ApplicationError('SCIENTIFIC_ENTRY_UNAVAILABLE', 'این مطلب در حال حاضر در دسترس نیست.', {
          cause: error
        });
      }
      throw error;
    }

    if (!entry) {
      throw new ValidationError(`مطلبی با شناسه‌ی "${slug}" یافت نشد.`);
    }

    return entry.props;
  }
}
